import React from "react";

const buildPageItems = (currentPage, totalPages) => {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  if (currentPage <= 4) {
    return [1, 2, 3, 4, "ellipsis", totalPages];
  }

  if (currentPage >= totalPages - 3) {
    return [1, "ellipsis", totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  }

  return [
    1,
    "ellipsis",
    currentPage - 1,
    currentPage,
    currentPage + 1,
    "ellipsis-end",
    totalPages,
  ];
};

const PaginationBar = ({
  page,
  totalPages,
  limit,
  onPageChange,
  onLimitChange,
  limits = [10, 20, 50],
  className = "",
}) => {
  const pageItems = buildPageItems(page, totalPages);

  return (
    <div className={`ui-pagination ${className}`.trim()}>
      <div className="ui-pagination__limit">
        <label htmlFor="rows-limit">Row Per Page</label>
        <select
          id="rows-limit"
          value={limit}
          onChange={(event) => onLimitChange(parseInt(event.target.value, 10))}
        >
          {limits.map((value) => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </select>
      </div>

      <div className="ui-pagination__pages">
        <button type="button" onClick={() => onPageChange(page - 1)} disabled={page === 1}>
          &#8249;
        </button>

        {pageItems.map((item) =>
          typeof item === "number" ? (
            <button
              key={item}
              type="button"
              onClick={() => onPageChange(item)}
              className={item === page ? "is-active" : ""}
            >
              {item}
            </button>
          ) : (
            <span key={item} className="ui-pagination__ellipsis" aria-hidden="true">
              ...
            </span>
          ),
        )}

        <button
          type="button"
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages}
        >
          &#8250;
        </button>
      </div>
    </div>
  );
};

export default PaginationBar;
